export default () => ({
  growthbookPayload: {},
})
